export default "__VITE_ASSET__56rt1BrX__"